import type { Page } from '../../types';

const detectedBribery: Page[] = [
  {
    pageType: 'question',
    title: 'Detected bribery',
    name: 'detected-bribery-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of detected bribery to declare?',
        name: 'detected_bribery_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Detected bribery',
    name: 'detected-bribery',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'detected_bribery_instances' },
        { title: 'Total Value', field: 'detected_bribery' },
      ],
    },
    disabled: [
      {
        field: 'detected_bribery_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'radio',
        title: 'Is this related to Covid 19 activity?',
        name: 'detected_bribery_c19',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'detected_bribery_instances',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'detected_bribery',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'detected_bribery_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default detectedBribery;





